import React, { useState } from "react";

const clamp = (n, min, max) => Math.min(Math.max(n, min), max);

const buildPages = (current, total) => {
  const pages = [];
  if (total <= 0) return pages;

  const c = clamp(current, 1, total);
  pages.push(1);

  let surrounding_page_count = window.innerWidth < 600 ? 0 : 1;

  const left = Math.max(2, c - surrounding_page_count);
  const right = Math.min(total - 1, c + surrounding_page_count);

  if (left > 2) pages.push("gap");
  for (let p = left; p <= right; p++) pages.push(p);
  if (right < total - 1) pages.push("gap");

  if (total > 1) pages.push(total);
  return pages;
};

const Pagination = ({
  currentPage = 1,
  totalPages = 1,
  ariaLabel = "Pagination",
  onChange,
}) => {
  const c = clamp(currentPage, 1, Math.max(1, totalPages));
  const [pages, updatePages] = useState(buildPages(c, totalPages));
  const prevPage = clamp(c - 1, 1, totalPages);
  const nextPage = clamp(c + 1, 1, totalPages);

  const goTo = page => {
    if (!onChange) return;
    const newPages = buildPages(page, totalPages);
    updatePages(newPages);
    const clamped = clamp(page, 1, Math.max(1, totalPages));
    if (clamped !== c) onChange(clamped);
  };

  const showPrev = totalPages > 1 && c > 1;
  const showNext = totalPages > 1 && c < totalPages;

  return (
    <nav className="find-office-pagination__pager" aria-label={ariaLabel}>
      {/* Prev */}
      {showPrev && (
        <button
          type="button"
          className="pager__arrow"
          data-action="prev"
          data-page={prevPage}
          aria-label="Previous page"
          disabled={c <= 1 || totalPages <= 1}
          onClick={() => goTo(prevPage)}
        >
          <i className="far fa-chevron-left" aria-hidden="true"></i>
        </button>
      )}

      {/* Numbers */}
      <ul className="pager__list" role="list">
        {pages.map((p, i) =>
          p === "gap" ? (
            <li key={`gap-${i}`} className="pager__ellipsis" aria-hidden="true">
              …
            </li>
          ) : (
            <li key={p}>
              <button
                type="button"
                className={`pager__page-btn${p === c ? " is-active" : ""}`}
                data-action="page"
                data-page={p}
                aria-current={p === c ? "page" : undefined}
                aria-label={`Page ${p}`}
                onClick={() => goTo(p)}
              >
                {p}
              </button>
            </li>
          ),
        )}
      </ul>

      {/* Next */}
      {showNext && (
        <button
          type="button"
          className="pager__arrow"
          data-action="next"
          data-page={nextPage}
          aria-label="Next page"
          disabled={c >= totalPages || totalPages <= 1}
          onClick={() => goTo(nextPage)}
        >
          <i className="far fa-chevron-right" aria-hidden="true"></i>
        </button>
      )}
    </nav>
  );
};

export default Pagination;
